import { CalendarDateEntry } from './CalendarDateEntry'

export class Calendar {
  constructor (data = {}) {
    this.timePeriods = {} // see http://localhost:8000/api/v1/doc#!/map/get_api_v1_map for field description
    this.calendarActivator = false // for calendar activation

    for (const [formattedTime, calendarEntry] of Object.entries(data)) {
      if (!(formattedTime in this.timePeriods)) {
        this.timePeriods[formattedTime] = []
      }

      for (const entry of calendarEntry) {
        this.timePeriods[formattedTime].push(new CalendarDateEntry(entry))
      }
    }
  }

  getAllowedTravelDates () {
    return (value) => Object.keys(this.timePeriods).includes(value)
  }

  getFirstTimePeriod () {
    return Object.keys(this.timePeriods).length > 0 ? Object.keys(this.timePeriods)[0] : null
  }

  getLastTimePeriod () {
    const periods = Object.keys(this.timePeriods)
    return periods.length > 0 ? periods[periods.length - 1] : null
  }

  getUsersByDay (time) {
    if (!(time in this.timePeriods)) {
      return []
    } else {
      return this.timePeriods[time].map(entry => entry.user).filter((item, index, self) =>
        index === self.findIndex(entry => entry.userId === item.userId)
      ).sort((a, b) => a.email > b.email)
    }
  }

  getTravelsByUser (time, userId) {
    if (!(time in this.timePeriods)) {
      return []
    } else {
      return this.timePeriods[time].filter(entry => entry.user.userId === userId).map(entry => entry.travel).sort((a, b) => a.datetimestart > b.datetimestart)
    }
  }
}
